module.exports = __webpack_public_path__ + "img/smart-scan-7.747d7121.png";